import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  spaceId: number | string;
  portalId: string;
  sourceId: string;
};

const [usePollForDuplicatePortal, pollForDuplicatePortal] = createAsyncAction(
  "portals/pollForDuplicatePortal",
  async ({ portalId }: Args) => {
    const res = await API.call<{ portal: string }>({
      endpoint: `portals/${portalId}`,
      method: "GET",
    });
    return { ...res, result: res.result.portal };
  }
);

export default usePollForDuplicatePortal;
export { pollForDuplicatePortal };
